export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST';
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE';
export const UPDATE_ADDRESS_RESET = 'UPDATE_ADDRESS_RESET';
export const updateAddressSuccess = (payload) => ({
    type: UPDATE_ADDRESS_SUCCESS,
    payload,
});
export const updateAddressRequest = (payload) => ({
    type: UPDATE_ADDRESS_REQUEST,
    payload,
});
export const updateAddressFailure = (payload) => ({
    type: UPDATE_ADDRESS_FAILURE,
    payload,
});
export const updateAddressReset = () => ({
    type: UPDATE_ADDRESS_RESET,
});
